// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { ADDRESS_SELECTED } from 'actions/addressSelected';
import { ENROLLMENT_USER_REVIEW } from 'actions/enrollmentUserReview';
import { MANUAL_ADDRESS_FORM_DISPLAYED } from 'actions/manualAddressFormDisplayed';
import { PROGRESS_CLEARED } from 'actions/progressCleared';

export const initialState = {
  isManualForm: false,
  addressData: {
    selectedAddressSuggestionData: null,
  },
  address2Data: '',
};

const addressAutocompleteReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { payload, type } = action;
    switch (type) {
      case ADDRESS_SELECTED:
        draft.addressData = payload.addressData;
        draft.address2Data = payload.address2Data;
        break;
      case MANUAL_ADDRESS_FORM_DISPLAYED:
        draft.isManualForm = true;
        break;
      case ENROLLMENT_USER_REVIEW:
        return initialState;
      case PROGRESS_CLEARED:
        return initialState;
    }
  });

export default addressAutocompleteReducer;
